<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-items">
                <template slot="button-content">
                    <i class="cus-folder-picture"></i>
                    Amendments {{ showCount }}
                </template>
                <b-dropdown-item @click="showList">
                    <i class="cus-folder-picture"></i>
                    View Amendments {{ showCount }}
                </b-dropdown-item>

                <li class="dropdown-divider" v-if="isAllowAddAmmendment"></li>

                <b-dropdown-item
                    v-if="isAllowAddAmmendment"
                    @click.stop="openModal(AMENDMENTS.VIEWS.UPDATE)"
                >
                    <i class="cus-add"></i>
                    Add Amendment
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text id="tab-amendment-content">
            <ListAmendments :key="keyview" v-on="$listeners" />
        </b-card-text>
    </b-tab>
</template>

<script>
/**
 * @name SoapTabAmendment
 * @see apps/assets/js/module/patient/soap/soap.js
 * @see apps/application/controllers/soap/amendment.php
 * @see apps/application/views/staff/patient/soap/sub/navbar.php
 * @see apps/application/views/staff/patient/soap/sub/amendment/list.php
 * @see apps/application/views/staff/patient/soap/sub/amendment/confirmation.php
 * @see apps/application/views/staff/patient/soap/sub/amendment/create_update.php
 */

import AMENDMENTS from "@/constants/amendments";

const LOCKED = 1;

export default {
    components: {
        ListAmendments: () =>
            import("@/components/soap-amendments/amendments-list")
    },
    computed: {
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        },
        count() {
            let count = this.$store.getters["soap/amendmentsCountsSoap"];
            return count;
        },
        isAllowAddAmmendment() {
            return (
                this.isOwner(this.soapDetails.business_id) &&
                this._hasAccess("soap.amendment.create")
            );
        },
        showCount() {
            return this.count === 0 || this.count > 0 ? `(${this.count})` : "";
        }
    },
    mounted() {
        this.$store.dispatch(
            "soap/getAmendmentsCountSoap",
            this.soapDetails.id
        );
    },
    data() {
        return {
            keyview: 0,
            AMENDMENTS,
            LOCKED
        };
    },
    watch: {},
    methods: {
        showList() {
            this.keyview += 1;

            this.$emit("scroll-to-element", "tab-amendment-content");
        },
        openModal(key) {
            this.$emit("open-modal", key);
        }
    }
};
</script>
